const initialState = {
  nationality: {
    frequency: '',
    iso2: '',
    iso3: '',
    name: ''
  },
  identCard: {
    key: '',
    name: ''
  },
  identType: ''
}

const IdentDataModule = {
  namespaced: true,
  state: initialState,
  getters: {
    identData: state => {
      return state
    }
  },
  actions: {},
  mutations: {
    setIdentData (state, { nationality, identCard, identType }) {
      state.identCard = identCard
      state.nationality = nationality
      state.identType = identType
    },
    resetIdentType (state) {
      state.identData.identType = ''
    },
    resetState (state) {
      Object.assign(state, initialState)
    }
  }
}

export default IdentDataModule
